<template>
    <div>
        <div class="loader" v-bind:class="ifLoading">
            <TheSpinner />
        </div>
        <div v-if="loading">
            <div class="bgstyle bg-primary-orange overflow-hidden pb-10 md:px-10">
                <div class=" md:text-center newsrow">
                    <ul class="news md:inline-block md:text-left">
                        <li :key="newsItem.ID" class="text-xl pt-3 mt-8 md:pr-6" v-for="newsItem in items[1]" v-if="newsItem.title">
                            <news :news="newsItem"></news>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

    import news from "../news/teaserView";
    import TheSpinner from "../TheSpinner"

    export default {
        name: 'homepage',
        components: {
            news,
            TheSpinner
        },
        data(){
            return{
                loading: false,
                items: []
            }
        },
        created: function(){
            const baseURI = 'https://api.pgsi2020.de/api/file/news.json'
            this.$http.get(baseURI)
                .then((result) => {
                    this.items = result.data,
                        this.loading = true
                })
        },
        computed: {
            ifLoading() {
                if(this.loading){
                    return 'loaded';
                }else{
                    return 'isLoading';
                }
            }
        },
        methods: {
            getArticleLayout(layout) {
                switch (layout) {
                    case 'countdown':
                        return countdown
                    case 'news':
                        return news
                    case 'formular':
                        return formular
                    case 'instagram':
                        return instagram
                    case 'teilnehmer':
                        return teilnehmer
                    case 'spielplan':
                        return spielplan
                    case 'ergebnisse':
                        return ergebnisse
                    default:
                        return error
                }
            },
            test(){
                alert('hello world!');
            }
        }
    }
</script>

<style lang="scss">
    .bgstyle{
        background-image: url('http://api.pgsi2020.de/images/background_news.png');
        background-repeat: no-repeat;
        background-size: contain;
        @screen md {
            background-size: 30%;
        }
        background-position: top right;
    }

    @screen md {

        .newsrow{
            max-width: 1800px;
            margin: 0 auto;
        }

        ul.news li{
            width: 50%;
            display: inline-block;
            vertical-align: top;
            &:nth-child(n+10){
                width: 33%;
                h2{
                    span{
                        font-size: 12px !important;
                    }
                }
            }
            img{
                border: 20px solid transparent;
                //@apply border-primary-green;
                transition: all ease-in .4s;
            }
            &:hover{
                img{
                    border: 20px solid red;
                    @apply border-primary-green;
                }
                h2{
                    box-shadow: 0 0px 30px 3px rgba(0, 0, 0, 0.7)
                }
            }
        }
    }

</style>
